import { makeStyles, Theme } from '@material-ui/core';

export const useNftCollectionCardStyles = makeStyles<Theme>((theme) => ({
  nftsItem: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    background: '#292A2F',
    borderRadius: '12px',
    padding: '24px',
    flex: '0 1 calc( ( 100% - 96px ) / 4 )',
    [theme.breakpoints.down('sm')]: {
      flex: '0 1 calc( ( 100% - 96px ) / 2 )',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      flex: '1',
    },

    '& > h5': {
      marginTop: '16px',
      marginBottom: '4px',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '24px',
      color: '#FAFAFA',
      cursor: 'pointer',
    },
    '& > span': {
      color: '#949494',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      marginBottom: '16px',
      cursor: 'pointer',
    },
  },
  nftsItemImages: {
    cursor: 'pointer',
    '& > *:first-child': {
      marginLeft: '0px',
    },
    '& > div': {
      position: 'absolute',
      top: '0',
      right: '0',
      width: '72px',
      height: '72px',
      background: '#000000A0',
      // transform: 'perspective(62px) rotateY(17deg)',
      borderRadius: '8px',
      border: '1px solid #FFFFFF26',
      boxShadow: '-8px 0px 12px #1B1C2280',
      '& > span': {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
        color: '#ffffff',
        position: 'absolute',
        top: '26px',
        right: '26px',
      },
    },
  },
}));
